<div
	*ngIf="isLimitCalculatorEnabled$ | async"
	class="obg-m-deposit-limit-calculator-banner"
	test-id="deposit-calculator-banner"
	data-test-id="deposit-calculator-banner"
>
	<div class="deposit-limit-calculator-container">
		<img
			class="deposit-limit-banner-image"
			test-id="deposit-limit-calculator-banner-image"
			data-test-id="deposit-limit-calculator-banner-image"
			obgImageContent="deposit-limit-calculator.image.deposit-limit-exceeded"
			obgImageContentGroup="common"
		/>
		<div class="deposit-limit-banner-text" test-id="deposit-limit-banner-text">
			<p class="deposit-limit-banner-question">{{ "deposit-limit-calculator.question" | translate }}</p>
			<p class="deposit-limit-banner-find-out">{{ "deposit-limit-calculator.find-out" | translate }}</p>
		</div>
	</div>
	<a
		class="deposit-limit-banner-link"
		test-id="deposit-limit-calculator-banner-link"
		data-test-id="deposit-limit-calculator-banner-link"
		(click)="uiInteractionLinkClick()"
		[obgRouteLink]="depositCalculatorRoute"
		>{{ "deposit-limit-calculator.get-started" | translate }}</a
	>
</div>
